import { StateStorage } from "../StateStorage";

export type Reducer<TState, TAction> = (state: TState, action: TAction) => TState;

export default function persistStateReducer<TState, TAction>(storage: StateStorage<TState>, initialState: TState, innerReducer: Reducer<TState, TAction>): Reducer<TState, TAction> {
    const obj = storage.get() ?? initialState;
    return (state = obj, action) => {
        const res = innerReducer(state, action);
        storage.set(res);
        return res;
    };
}